module.exports = {
          srcSet: __webpack_public_path__ + "6fad8d82d3e8c9c7b27111d18be61feb-501.png"+" 501w",
          images:[ {path: __webpack_public_path__ + "6fad8d82d3e8c9c7b27111d18be61feb-501.png",width: 501,height: 282}],
          src: __webpack_public_path__ + "6fad8d82d3e8c9c7b27111d18be61feb-501.png",
          toString:function(){return __webpack_public_path__ + "6fad8d82d3e8c9c7b27111d18be61feb-501.png"},
          
          width: 501,
          height: 282
        }